import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  selectedType : "",
};

export const corpoSlice = createSlice({
    name: "corpo",
    initialState: initialState,
    reducers: {
      update_corpo: (state, action) => {
        state.selectedType = action.payload;
      },
}})
export default corpoSlice.reducer;